export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    background: p => p.tertiaryDark,
    pDark: p => p.primaryDark,
    pLight: p => p.primaryLight,
    iconColor: p => p.primaryLight,
    navbarBg: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    pDark: p => p.primaryDark,
    pLight: p => p.primaryLight,
    iconColor: p => p.primaryDark,
    navbarBg: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    pDark: p => p.primaryDark,
    pLight: p => p.primaryLight,
    iconColor: p => p.primaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
